// services/index.js
// Import services
import { UserService } from './UserService';
import { ProfileManager } from './ProfileManager';
import { SubscriptionService } from './SubscriptionService';
import { ReportService } from './ReportService';
import { WordService } from './WordService';
import { EnterpriseService } from './EnterpriseService';
import { EnterpriseAdminService } from './EnterpriseAdminService';
import { AdminService } from './AdminService';
import { ReportTypeService } from './ReportTypeService';
import { CustomInstructionService } from './CustomInstructionService';
import { BiometricService } from './BiometricService';
import { MacroService } from './MacroService';
import { StatisticService } from './StatisticService';
import { DraftService } from './DraftService';
import { OcrService } from './ocrService';
import { SystemService } from './SystemService';
import { ShortcutService } from './ShortcutService';
import { ContactService } from './ContactService';

// Managers
import { offlineManager } from './OfflineManager';
import { tokenManager } from './TokenManager';
import { authManager } from './AuthManager';
import { secureTokenStorage } from './SecureTokenStorage';
import { tokenRecoveryService } from './TokenRecoveryService';

// Create singleton instances
export const userService = new UserService();
export const profileManager = new ProfileManager();
export const subscriptionService = new SubscriptionService();
export const reportService = new ReportService();
export const wordService = new WordService();
export const enterpriseService = new EnterpriseService();
export const enterpriseAdminService = new EnterpriseAdminService();
export const adminService = new AdminService();
export const reportTypeService = new ReportTypeService();
export const customInstructionService = new CustomInstructionService();
export const biometricService = new BiometricService();
export const macroService = new MacroService();
export const statisticService = new StatisticService();
export const draftService = new DraftService();
export const ocrService = new OcrService();
export const systemService = new SystemService();
export const shortcutService = new ShortcutService();
export const contactService = new ContactService();


// Export managers (already singletons)
export { offlineManager };
export { tokenManager };
export { authManager };
export { secureTokenStorage };
export { tokenRecoveryService };

// Export base class for extension
export { BaseService } from './BaseService';